import {
	API_GET_FOCUSED_FOLDERS,
	API_GET_FOCUSED_FOLDERS_SUCCESS,
	API_GET_FOCUSED_FOLDERS_FAIL,
	SET_FOCUSED_FOLDERS,
	RESET_FOCUSED_FOLDERS,
	API_POST_PHOTO_FOLDER,
	API_POST_PHOTO_FOLDER_SUCCESS,
	API_POST_PHOTO_FOLDER_FAIL,
	API_DELETE_PHOTO_FOLDER_SUCCESS,
	API_DELETE_PHOTO_FOLDER_FAIL,
	API_VALIDATE_FOLDERS_SUCCESS,
	SET_SECRETARY_MODE,
	API_GET_PATIENT_EXISTING_FOLDER,
	API_GET_PATIENT_EXISTING_FOLDER_FAIL,
	API_GET_PATIENT_EXISTING_FOLDER_SUCCESS,
	API_PATCH_OPEN_FOLDER,
	API_PATCH_OPEN_FOLDER_SUCCESS,
	API_PATCH_OPEN_FOLDER_FAIL,
	API_PATCH_FOLDER_PATIENT,
	API_PATCH_FOLDER_PATIENT_FAIL,
	API_PATCH_FOLDER_PATIENT_SUCCESS,
	API_PATCH_CANCEL_FOLDER,
	API_PATCH_CANCEL_FOLDER_FAIL,
	API_PATCH_CANCEL_FOLDER_SUCCESS,
	API_UPDATE_PHOTO_FOLDER_FAIL,
	API_UPDATE_PHOTO_FOLDER_SUCCESS,
	API_GET_ALL_FOLDER,
	API_GET_ALL_FOLDER_FAIL,
	API_GET_ALL_FOLDER_SUCCESS,
	API_GET_SEARCH_FOLDERS,
	API_GET_SEARCH_FOLDERS_FAIL,
	API_GET_SEARCH_FOLDERS_SUCCESS,
	API_PATCH_OPENED_BY_FAIL,
	API_PATCH_PAUSE_FOLDER_VALIDATION,
	API_PATCH_PAUSE_FOLDER_VALIDATION_FAIL,
	API_PATCH_PAUSE_FOLDER_VALIDATION_SUCCESS,
	CLOSE_BARCODE_WARNING,
	CLOSE_OPENEDBY_WARNING,
	API_PATCH_COMMENTS,
	API_PATCH_COMMENTS_SUCCESS,
	API_PATCH_COMMENTS_FAIL,
	API_PATCH_FOLDER_GESLAB_ALERT,
	API_PATCH_FOLDER_GESLAB_ALERT_FAIL,
	API_PATCH_FOLDER_GESLAB_ALERT_SUCCESS,
	API_PATCH_FOLDER_FAMILY_LINK,
	API_PATCH_FOLDER_FAMILY_LINK_FAIL,
	API_PATCH_FOLDER_FAMILY_LINK_SUCCESS,
	API_GET_SEARCH_FOLDERS_FAMILY_LINK,
	API_GET_SEARCH_FOLDERS_FAMILY_LINK_SUCCESS,
	API_GET_SEARCH_FOLDERS_FAMILY_LINK_FAIL,
	API_GET_WAITING_TUBES_FOLDERS_SUCCESS,
	API_GET_WAITING_ALIQUOTS_FOLDERS_SUCCESS,
	API_GET_MY_OPENED_FOLDERS_SUCCESS,
	API_DELETE_MY_OPENED_FOLDERS_SUCCESS,
	SET_TAB_RESULT,
	SET_TAB_PRESC,
	SET_TAB_TUBES,
	SET_TAB_ALIQUOT,
	RESET_ALIQUOTS_WAITING,
	API_GET_FOLDER_HELP_SUCCESS,
	API_PUT_ENDO_ANSWERS_SUCCESS,
} from "actions/folder";
import {
	API_PATCH_PATIENT_FOLDERMANAGER_FAIL,
	API_PATCH_PATIENT_FOLDERMANAGER_SUCCESS,
	API_GET_PATIENT_IATA_QRCODE,
	API_GET_PATIENT_IATA_QRCODE_SUCCESS,
	API_GET_PATIENT_IATA_DID_SUCCESS,
	API_CLEAR_PATIENT_IATA,
} from "actions/patient";
import { toast } from "react-toastify";
import {
	API_BULK_ANALYSES_PRESCRIPTION,
	API_BULK_ANALYSES_PRESCRIPTION_FAIL,
	API_BULK_ANALYSES_PRESCRIPTION_SUCCESS,
	API_DELETE_PRESCRIPTION_SUCCESS,
	API_DELETE_SCAN_PRESCRIPTION_SUCCESS,
	API_PATCH_PRESCRIPTION,
	API_PATCH_PRESCRIPTION_FAIL,
	API_PATCH_PRESCRIPTION_SUCCESS,
	API_POST_PRESCRIPTION,
	API_POST_PRESCRIPTION_FAIL,
	API_POST_PRESCRIPTION_SUCCESS,
	API_POST_SCAN_PRESCRIPTION,
	API_POST_SCAN_PRESCRIPTION_SUCCESS,
	API_POST_SCAN_PRESCRIPTION_FAIL,
	API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC,
	API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC_SUCCESS,
	API_POST_REPEATABLE_PRESCRIPTION,
	API_POST_REPEATABLE_PRESCRIPTION_FAIL,
	API_POST_REPEATABLE_PRESCRIPTION_SUCCESS,
	API_POST_PRESCRIPTION_SCAN_BARCODE,
	API_POST_PRESCRIPTION_SCAN_BARCODE_FAIL,
	API_POST_PRESCRIPTION_SCAN_BARCODE_SUCCESS,
	API_POST_SAFEPLACE_RESULT_PRESCRIPTION,
	API_POST_SAFEPLACE_RESULT_PRESCRIPTION_FAIL,
	API_POST_SAFEPLACE_RESULT_PRESCRIPTION_SUCCESS,
	API_POST_IATA_DID_PRESCRIPTION,
	API_POST_IATA_DID_PRESCRIPTION_SUCCESS,
	API_PUT_VALID_PRESCRIPTION_SCAN,
	API_PUT_VALID_PRESCRIPTION_SCAN_SUCCESS,
	API_PUT_QUALITY_PRESCRIPTION_SCAN,
	API_PUT_QUALITY_PRESCRIPTION_SCAN_SUCCESS,
	API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN,
	API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN_SUCCESS,
	API_GET_RELOAD_SCANS_SUCCESS,
	API_PUT_MOTIVATION_SUCCESS,
	API_PATCH_CHECK_ANALYSIS,
	API_PATCH_CHECK_ANALYSIS_SUCCESS,
	API_PATCH_PRESCRIPTION_CONTACT,
	API_PATCH_PRESCRIPTION_CONTACT_SUCCESS,
} from "actions/prescription";
import {
	API_PATCH_MULTIPLE_TUBE_SUCCESS,
	API_PATCH_MULTIPLE_TUBE,
	API_PATCH_TUBE,
	API_PATCH_TUBE_SUCCESS,
	API_DELETE_TUBE,
	API_DELETE_TUBE_FAIL,
	API_DELETE_TUBE_SUCCESS,
	API_POST_TUBE,
	API_POST_TUBE_FAIL,
	API_POST_TUBE_SUCCESS,
} from "actions/tube";
import { API_PATCH_QUESTIONANSWER_FAIL, API_PATCH_QUESTIONANSWER_SUCCESS } from "actions/questionAnswer";
import { createReducer } from "@reduxjs/toolkit";
import { ErrorAction, errorHandler } from "utils/error";
import { getVersion } from "services/prescription";
import { getVersion as getTubeVersion } from "services/tube";
import { getVersion as getFolderVersion } from "services/folder";
import { getVersion as getPaymentVersion } from "services/payment";
import { getVersion as getDepositVersion } from "services/deposit";
import { DEFAULT_CLIENT, V2_CLIENT } from "config/clientConstants";

import {
	API_GET_FOLDER_IS_PAID_FAIL,
	API_GET_FOLDER_IS_PAID,
	API_GET_FOLDER_IS_PAID_SUCCESS,
	API_GET_FOLDER_PAYMENT_CANCEL,
	API_GET_FOLDER_PAYMENT_CANCEL_SUCCESS,
	API_GET_FOLDER_PAYMENT_CANCEL_FAIL,
	API_POST_PAYMENT,
	API_POST_PAYMENT_SUCCESS,
	API_POST_PAYMENT_FAIL,
	API_GET_TERMINALS,
	API_GET_TERMINALS_SUCCESS,
	API_GET_TERMINALS_FAIL,
	API_POST_FOLDER_PAYMENT_REF,
	API_POST_FOLDER_PAYMENT_REF_SUCCESS,
	API_POST_FOLDER_PAYMENT_REF_FAIL,
} from "actions/payment";
import { API_GET_FOLDER_LOG, API_GET_FOLDER_LOG_FAIL, API_GET_FOLDER_LOG_SUCCESS } from "actions/log";
import {
	API_POST_COMMENT_FOLDER_HELP_SUCCESS,
	API_POST_COMMENT_FOLDER_HELP,
} from "actions/folderHelp";
import {
	API_PUT_DEPOSIT,
	API_PUT_DEPOSIT_SUCCESS,
	API_DELETE_DEPOSIT_SUCCESS,
} from "actions/deposit";
import {API_GET_FOLDER_HELP} from "actions/folder";

const initialState = {
	loading: false,
	analysisLoading: false,
	focusID: [],
	data: null,
	secretaryMode: null,
	existing: null,
	paid: { payments: [] },
	terminals: [],
	folders: [],
	searchedFolders: [],
	logs: {
		loading: false,
		list: [],
	},
	barcodeWarningOpen: false,
	barcode: "",
	openedByWarningOpen: false,
	foldersFamilyLink: [],
	foldersWaiting: {},
	aliquotWaiting: [],
	myOpenedFolders: [],
	tab: 0,
	qrSearch: null,
};

let folderIndex, prescriptionIndex, oldPrescriptionIndex, analysisIndex;

const toNumber = (value) => {
	if (value === null || value === undefined) return value;
	const num = typeof value === 'string' ? parseFloat(value) : Number(value);
	return isNaN(num) ? value : num;
};

const adaptPrescriptionResponse = (prescription, currentClient) => {
	try {
		if (!prescription || currentClient !== V2_CLIENT) {
			return prescription;
		}

		const adapted = { ...prescription };

		if (adapted.prescriberId !== undefined && adapted.prescriberId !== null && adapted.prescriber_id === undefined) {
			adapted.prescriber_id = toNumber(adapted.prescriberId);
		}
		if (adapted.patientId !== undefined && adapted.patientId !== null && adapted.patient_id === undefined) {
			adapted.patient_id = toNumber(adapted.patientId);
		}
		if (adapted.folderId !== undefined && adapted.folderId !== null && adapted.folder_id === undefined) {
			adapted.folder_id = toNumber(adapted.folderId);
		}
		if (adapted.billingCompanyId !== undefined && adapted.billingCompanyId !== null && adapted.billing_company_id === undefined) {
			adapted.billing_company_id = toNumber(adapted.billingCompanyId);
		}
		if (adapted.mylabPrescriptionId !== undefined && adapted.mylabPrescriptionId !== null && adapted.mylab_prescription_id === undefined) {
			adapted.mylab_prescription_id = toNumber(adapted.mylabPrescriptionId);
		}
		if (adapted.agencePrescriptionId !== undefined && adapted.agencePrescriptionId !== null && adapted.agence_prescription_id === undefined) {
			adapted.agence_prescription_id = adapted.agencePrescriptionId;
		}

		const fieldMap = {
			toBeFaxed: 'to_be_faxed',
			toBePhoned: 'to_be_phoned',
			toBeFaxedNumber: 'to_be_faxed_number',
			toBePhonedNumber: 'to_be_phoned_number',
			phoneBefore: 'phone_before',
			faxBefore: 'fax_before',
			accidentNumber: 'accident_number',
			accidentDate: 'accident_date',
			paperCopyToPatient: 'paper_copy_to_patient',
			faxToPatient: 'fax_to_patient',
			faxToPatientNumber: 'fax_to_patient_number',
			phoneToPatient: 'phone_to_patient',
			phoneToPatientNumber: 'phone_to_patient_number',
			showMylab: 'show_mylab',
			notificationMylab: 'notification_mylab',
			toBeCompleted: 'to_be_completed',
			toBeSampled: 'to_be_sampled',
			homePrescribed: 'home_prescribed',
			prescriberToCreateBySecretary: 'prescriber_to_create_by_secretary',
			doctorCopyToCreateBySecretary: 'doctor_copy_to_create_by_secretary',
			noPrescriber: 'no_prescriber',
			faxToBillingCompany: 'fax_to_billing_company',
			phoneToBillingCompany: 'phone_to_billing_company',
			faxToBillingCompanyNumber: 'fax_to_billing_company_number',
			phoneToBillingCompanyNumber: 'phone_to_billing_company_number',
			safeplaceCode: 'safeplace_code',
			safeplaceResult: 'safeplace_result',
			iataTravelPassId: 'iata_travel_pass_id',
			validationCount: 'validation_count',
			validityDate: 'validity_date',
			issueDate: 'issue_date',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.analyses && Array.isArray(adapted.analyses)) {
			const adaptedAnalyses = adapted.analyses.map((analysis) => {
				const adaptedAnalysis = { ...analysis };
				if (adaptedAnalysis.analysisLibraryId !== undefined && adaptedAnalysis.analysisLibraryId !== null && adaptedAnalysis.analysis_library_id === undefined) {
					adaptedAnalysis.analysis_library_id = toNumber(adaptedAnalysis.analysisLibraryId);
				}
				if (adaptedAnalysis.prescriptionId !== undefined && adaptedAnalysis.prescriptionId !== null && adaptedAnalysis.prescription_id === undefined) {
					adaptedAnalysis.prescription_id = toNumber(adaptedAnalysis.prescriptionId);
				}
				if (!adaptedAnalysis.question_answers) {
					adaptedAnalysis.question_answers = [];
				}
				return adaptedAnalysis;
			});
			adapted.analyses = adaptedAnalyses;
		} else if (!adapted.analyses) {
			adapted.analyses = [];
		}

		if (adapted.tubes && Array.isArray(adapted.tubes)) {
			const adaptedTubes = adapted.tubes.map((tube) => {
				const adaptedTube = { ...tube };
				if (adaptedTube.prescriptionId !== undefined && adaptedTube.prescriptionId !== null && adaptedTube.prescription_id === undefined) {
					adaptedTube.prescription_id = toNumber(adaptedTube.prescriptionId);
				}
				if (adaptedTube.analysisId !== undefined && adaptedTube.analysisId !== null && adaptedTube.analysis_id === undefined) {
					adaptedTube.analysis_id = toNumber(adaptedTube.analysisId);
				}
				return adaptedTube;
			});
			adapted.tubes = adaptedTubes;
		} else if (!adapted.tubes) {
			adapted.tubes = [];
		}

		if (!adapted.scans) {
			adapted.scans = [];
		}

		if (!adapted.systematic_questions) {
			adapted.systematic_questions = [];
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptPrescriptionResponse:', error);
		return prescription;
	}
};

const adaptTubeResponse = (tube, currentClient) => {
	try {
		if (!tube || currentClient !== V2_CLIENT) {
			return tube;
		}

		const adapted = { ...tube };

		if (adapted.prescriptionId !== undefined && adapted.prescriptionId !== null && adapted.prescription_id === undefined) {
			adapted.prescription_id = toNumber(adapted.prescriptionId);
		}
		if (adapted.analysisId !== undefined && adapted.analysisId !== null && adapted.analysis_id === undefined) {
			adapted.analysis_id = toNumber(adapted.analysisId);
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptTubeResponse:', error);
		return tube;
	}
};

const adaptPayloadResponse = (action, actionType, currentClient) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT && typeof data === 'object' && data !== null && !Array.isArray(data)) {
			const adaptedData = adaptPrescriptionResponse(data, currentClient);
			return {
				...payload,
				data: adaptedData,
			};
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptPayloadResponse:', error);
		return action.payload || {};
	}
};

const adaptTubePayloadResponse = (action, actionType, currentClient) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (Array.isArray(data)) {
				const adaptedData = data.map(tube => adaptTubeResponse(tube, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				const adaptedData = adaptTubeResponse(data, currentClient);
				return {
					...payload,
					data: adaptedData,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptTubePayloadResponse:', error);
		return action.payload || {};
	}
};

const adaptFolderResponse = (folder, currentClient) => {
	try {
		if (!folder || currentClient !== V2_CLIENT) {
			return folder;
		}

		const adapted = { ...folder };

		if (adapted.patientId !== undefined && adapted.patientId !== null && adapted.patient_id === undefined) {
			adapted.patient_id = toNumber(adapted.patientId);
		}
		if (adapted.centerId !== undefined && adapted.centerId !== null && adapted.center_id === undefined) {
			adapted.center_id = toNumber(adapted.centerId);
		}
		if (adapted.creatorId !== undefined && adapted.creatorId !== null && adapted.creator_id === undefined) {
			adapted.creator_id = toNumber(adapted.creatorId);
		}
		if (adapted.openedById !== undefined && adapted.openedById !== null && adapted.opened_by_id === undefined) {
			adapted.opened_by_id = toNumber(adapted.openedById);
		}
		if (adapted.validationPausedById !== undefined && adapted.validationPausedById !== null && adapted.validation_paused_by_id === undefined) {
			adapted.validation_paused_by_id = toNumber(adapted.validationPausedById);
		}
		if (adapted.familyLinkId !== undefined && adapted.familyLinkId !== null && adapted.family_link_id === undefined) {
			adapted.family_link_id = toNumber(adapted.familyLinkId);
		}

		const fieldMap = {
			takeNumber: 'take_number',
			jsonGenerated: 'json_generated',
			jsonGenerationDate: 'json_generation_date',
			validationPaused: 'validation_paused',
			validationPausedAt: 'validation_paused_at',
			validationPausedReason: 'validation_paused_reason',
			pausedAt: 'paused_at',
			geslabAlert: 'geslab_alert',
			geslabAlertComment: 'geslab_alert_comment',
			canceledReason: 'canceled_reason',
			isTemp: 'is_temp',
			isExpress: 'is_express',
			isFastLineRegister: 'is_fast_line_register',
			createdAt: 'created_at',
			updatedAt: 'updated_at',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.prescriptions && Array.isArray(adapted.prescriptions)) {
			const adaptedPrescriptions = adapted.prescriptions.map((prescription) => {
				return adaptPrescriptionResponse(prescription, currentClient);
			});
			adapted.prescriptions = adaptedPrescriptions;
		} else if (!adapted.prescriptions) {
			adapted.prescriptions = [];
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptFolderResponse:', error);
		return folder;
	}
};

const adaptFolderPayloadResponse = (action, actionType, currentClient) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (actionType === API_GET_FOCUSED_FOLDERS && data && !Array.isArray(data) && !data.items && !data.folders) {
				const adaptedFolder = adaptFolderResponse(data, currentClient);
				const patient = adaptedFolder.patient || null;
				
				const adaptedFolderWithoutPatient = { ...adaptedFolder };
				delete adaptedFolderWithoutPatient.patient;
				
				return {
					...payload,
					data: {
						folders: [adaptedFolderWithoutPatient],
						patient: patient,
					},
				};
			}
			
			if (actionType === API_GET_FOCUSED_FOLDERS && data.items && Array.isArray(data.items)) {
				const adaptedFolders = data.items.map(folder => adaptFolderResponse(folder, currentClient));
				const patient = adaptedFolders.length > 0 && adaptedFolders[0].patient 
					? adaptedFolders[0].patient 
					: null;
				
				return {
					...payload,
					data: {
						folders: adaptedFolders,
						patient: patient,
					},
				};
			}
			
			if (Array.isArray(data)) {
				const adaptedData = data.map(folder => adaptFolderResponse(folder, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				if (data.folders && Array.isArray(data.folders)) {
					const adaptedFolders = data.folders.map(folder => adaptFolderResponse(folder, currentClient));
					return {
						...payload,
						data: {
							...data,
							folders: adaptedFolders,
						},
					};
				} else {
					const adaptedData = adaptFolderResponse(data, currentClient);
					return {
						...payload,
						data: adaptedData,
					};
				}
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptFolderPayloadResponse:', error);
		return action.payload || {};
	}
};

const adaptPaymentResponse = (payment, currentClient) => {
	try {
		if (!payment || currentClient !== V2_CLIENT) {
			return payment;
		}

		const adapted = { ...payment };

		const fieldMap = {
			transactionId: 'transaction_id',
			invoiceReference: 'invoice_reference',
			prescriptionId: 'prescription_id',
			reasonInvoice: 'reason_invoice',
			reasonInvoiceComment: 'reason_invoice_comment',
			voucherCode: 'voucher_code',
			createdAt: 'created_at',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.folder && typeof adapted.folder === 'object' && adapted.folder.id !== undefined) {
			if (adapted.folder_id === undefined) {
				adapted.folder_id = toNumber(adapted.folder.id);
			}
		}

		if (adapted.prescription && typeof adapted.prescription === 'object' && adapted.prescription.id !== undefined) {
			if (adapted.prescription_id === undefined) {
				adapted.prescription_id = adapted.prescription.id;
			}
		}

		if (adapted.casing && typeof adapted.casing === 'object' && adapted.casing.id !== undefined) {
			if (adapted.casing_id === undefined) {
				adapted.casing_id = toNumber(adapted.casing.id);
			}
		}

		if (adapted.cashier && typeof adapted.cashier === 'object' && adapted.cashier.id !== undefined) {
			if (adapted.cashier_id === undefined) {
				adapted.cashier_id = toNumber(adapted.cashier.id);
			}
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptPaymentResponse:', error);
		return payment;
	}
};

const adaptPaymentPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getPaymentVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (data.payments && Array.isArray(data.payments)) {
				const adaptedPayments = data.payments.map((payment) => adaptPaymentResponse(payment, currentClient));
				return {
					...payload,
					data: {
						...data,
						payments: adaptedPayments,
					},
				};
			} else if (Array.isArray(data)) {
				const adaptedData = data.map((item) => adaptPaymentResponse(item, currentClient));
				return {
					...payload,
					data: adaptedData,
				};
			} else if (typeof data === 'object' && data !== null) {
				const adaptedData = adaptPaymentResponse(data, currentClient);
				return {
					...payload,
					data: adaptedData,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptPaymentPayloadResponse:', error);
		return action.payload || {};
	}
};

const adaptDepositResponse = (deposit, currentClient) => {
	try {
		if (!deposit || currentClient !== V2_CLIENT) {
			return deposit;
		}

		const adapted = { ...deposit };

		const fieldMap = {
			prelDate: 'prel_date',
			createdDate: 'created_date',
		};

		Object.keys(fieldMap).forEach((camelKey) => {
			if (adapted[camelKey] !== undefined && adapted[fieldMap[camelKey]] === undefined) {
				adapted[fieldMap[camelKey]] = adapted[camelKey];
			}
		});

		if (adapted.folder && typeof adapted.folder === 'object' && adapted.folder.id !== undefined) {
			if (adapted.folder_id === undefined) {
				adapted.folder_id = toNumber(adapted.folder.id);
			}
		}

		if (adapted.sampler && typeof adapted.sampler === 'object' && adapted.sampler.id !== undefined) {
			if (adapted.sampler_id === undefined) {
				adapted.sampler_id = toNumber(adapted.sampler.id);
			}
		}

		if (adapted.prelPlace && typeof adapted.prelPlace === 'object' && adapted.prelPlace.id !== undefined) {
			if (adapted.prel_place_id === undefined) {
				adapted.prel_place_id = toNumber(adapted.prelPlace.id);
			}
		}

		return adapted;
	} catch (error) {
		console.error('Error in adaptDepositResponse:', error);
		return deposit;
	}
};

const adaptDepositPayloadResponse = (action, actionType) => {
	try {
		const payload = action.payload || {};
		const data = payload.data;
		const currentClient = action.meta?.previousAction?.payload?.client || getDepositVersion(actionType).currentClient;

		if (!data) {
			return payload;
		}

		if (currentClient === V2_CLIENT) {
			if (data.deposit) {
				const adaptedDeposit = adaptDepositResponse(data.deposit, currentClient);
				return {
					...payload,
					data: {
						...data,
						deposit: adaptedDeposit,
					},
				};
			} else if (typeof data === 'object' && data !== null) {
				const adaptedData = adaptDepositResponse(data, currentClient);
				return {
					...payload,
					data: adaptedData,
				};
			}
		}

		return payload;
	} catch (error) {
		console.error('Error in adaptDepositPayloadResponse:', error);
		return action.payload || {};
	}
};

const folderManager = createReducer(initialState, {
	/** USERS **/
	[SET_FOCUSED_FOLDERS]: (state, action) => {
		state.focusID = action.payload;
	},
	[SET_SECRETARY_MODE]: (state, action) => {
		state.secretaryMode = action.payload;
	},
	[API_GET_FOCUSED_FOLDERS]: (state, action) => {
		state.loading = true;
		state.error = false;
		state.barcodeWarningOpen = false;
		state.openedByWarningOpen = false;
	},
	[API_GET_FOCUSED_FOLDERS_FAIL]: (state, action) => {
		errorHandler("Dossier", ErrorAction.READ, action.error);

		state.loading = false;
		state.analysisLoading = false;
		state.error = "Error getting folders";
		state.data = null;
	},
	[API_GET_FOCUSED_FOLDERS_SUCCESS]: (state, action) => {
		state.loading = false;
		state.analysisLoading = false;
		state.error = false;
		try {
			console.log('API_GET_FOCUSED_FOLDERS_SUCCESS - raw action:', action);
			const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_GET_FOCUSED_FOLDERS).currentClient;
			console.log('API_GET_FOCUSED_FOLDERS_SUCCESS - client:', client);
			const adaptedPayload = adaptFolderPayloadResponse(action, API_GET_FOCUSED_FOLDERS, client);
			console.log('API_GET_FOCUSED_FOLDERS_SUCCESS - adapted payload:', adaptedPayload);
			
			if (adaptedPayload && adaptedPayload.data) {
				if (!adaptedPayload.data.folders && Array.isArray(adaptedPayload.data)) {
					const patient = adaptedPayload.data[0]?.patient || null;
					state.data = {
						folders: adaptedPayload.data,
						patient: patient,
					};
					state.folders = adaptedPayload.data;
					console.log('API_GET_FOCUSED_FOLDERS_SUCCESS - set folders from array:', adaptedPayload.data.length);
				} else if (adaptedPayload.data.folders && Array.isArray(adaptedPayload.data.folders)) {
					state.data = adaptedPayload.data;
					state.folders = adaptedPayload.data.folders;
					console.log('API_GET_FOCUSED_FOLDERS_SUCCESS - set folders from data.folders:', adaptedPayload.data.folders.length);
				} else if (adaptedPayload.data.id) {
					const patient = adaptedPayload.data.patient || null;
					const folderWithoutPatient = { ...adaptedPayload.data };
					delete folderWithoutPatient.patient;
					state.data = {
						folders: [folderWithoutPatient],
						patient: patient,
					};
					state.folders = [folderWithoutPatient];
					console.log('API_GET_FOCUSED_FOLDERS_SUCCESS - set single folder:', folderWithoutPatient.id);
				} else {
					console.warn('API_GET_FOCUSED_FOLDERS_SUCCESS - unexpected data structure:', adaptedPayload.data);
					state.data = adaptedPayload.data;
					state.folders = [];
				}
			} else {
				console.warn('API_GET_FOCUSED_FOLDERS_SUCCESS - no data in adapted payload');
				state.data = null;
				state.folders = [];
			}
			console.log('API_GET_FOCUSED_FOLDERS_SUCCESS - final state:', { foldersCount: state.folders.length, hasPatient: !!state.data?.patient });
		} catch (error) {
			console.error('Error in API_GET_FOCUSED_FOLDERS_SUCCESS:', error);
			console.error('Error stack:', error.stack);
			state.error = "Error processing folder data";
			state.data = null;
			state.folders = [];
		}
	},
	[RESET_FOCUSED_FOLDERS]: (state, action) => {
		state.focusID = [];
		state.data = [];
	},
	[API_PATCH_PATIENT_FOLDERMANAGER_SUCCESS]: (state, action) => {
		state.data.patient = action.payload.data;
	},
	[API_PATCH_PATIENT_FOLDERMANAGER_FAIL]: (state, action) => {
		errorHandler("Patient", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_PRESCRIPTION_FAIL]: (state, action) => {
		errorHandler("Prescription", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_PRESCRIPTION_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_PATCH_PRESCRIPTION).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_PATCH_PRESCRIPTION, client);
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);

			if (folderIndex > -1 && state.data.folders[folderIndex]) {
				prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex((elt) => 
					Number(elt.id) === Number(adaptedPayload.data.id)
				);

				if (prescriptionIndex > -1) {
					const existingPrescription = state.data.folders[folderIndex].prescriptions[prescriptionIndex];
					const adaptedPrescription = adaptPrescriptionResponse(adaptedPayload.data, client);
					state.data.folders[folderIndex].prescriptions = [
						...state.data.folders[folderIndex].prescriptions.slice(0, prescriptionIndex),
						{
							...existingPrescription,
							...adaptedPrescription,
							analyses: adaptedPrescription.analyses && adaptedPrescription.analyses.length > 0 
								? adaptedPrescription.analyses 
								: (existingPrescription.analyses || []),
							tubes: adaptedPrescription.tubes && adaptedPrescription.tubes.length > 0 
								? adaptedPrescription.tubes 
								: (existingPrescription.tubes || []),
							scans: adaptedPrescription.scans && adaptedPrescription.scans.length > 0 
								? adaptedPrescription.scans 
								: (existingPrescription.scans || []),
							systematic_questions: adaptedPrescription.systematic_questions && adaptedPrescription.systematic_questions.length > 0 
								? adaptedPrescription.systematic_questions 
								: (existingPrescription.systematic_questions || []),
						},
						...state.data.folders[folderIndex].prescriptions.slice(prescriptionIndex + 1)
					];
				}
			}
		}
	},
	[API_PATCH_MULTIPLE_TUBE]: (state, action) => {},

	[API_PATCH_MULTIPLE_TUBE_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getTubeVersion(API_PATCH_MULTIPLE_TUBE).currentClient;
			const adaptedPayload = adaptTubePayloadResponse(action, API_PATCH_MULTIPLE_TUBE, client);
			if (!adaptedPayload.data.success) {
				state.barcodeWarningOpen = true;
			} else {
				let data = adaptedPayload.data.data;
				if (data && state.data.folders)
					state.data.folders.forEach((folder) => {
						if (folder.prescriptions)
							folder.prescriptions.forEach((presc) => {
								if (presc.tubes)
									presc.tubes.forEach((tube) => {
										if (data.tubes.includes(tube.id)) {
											if (data.status !== undefined) {
												tube.status = data.status;
											}
											if (data.provider_barcode !== undefined) {
												tube.provider_barcode = data.provider_barcode;
											}
											if (data.untaken_reason !== undefined) {
												tube.untaken_reason = data.untaken_reason;
											}
											if (data.sampling_time !== undefined) {
												tube.sampling_time = data.sampling_time;
											}
											if (data.original !== undefined) {
												tube.original = data.original;
											}
											if (data.nature_reason !== undefined) {
												tube.nature_reason = data.nature_reason;
											}
										}
									});
							});
					});
			}
		}
	},

	[API_POST_PRESCRIPTION_FAIL]: (state, action) => {
		errorHandler("Prescription", ErrorAction.CREATE, action.error);
	},
	[API_POST_PRESCRIPTION_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_POST_PRESCRIPTION).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_POST_PRESCRIPTION, client);
			const folderId = adaptedPayload.data.folder_id || adaptedPayload.data.folderId || action.meta?.previousAction?.payload?.folderId;
			folderIndex = state.data.folders.findIndex((elt) => elt.id === folderId);
			if (folderIndex > -1) {
				const adaptedPrescription = adaptPrescriptionResponse(adaptedPayload.data, client);
				state.data.folders[folderIndex].prescriptions = [
					...state.data.folders[folderIndex].prescriptions,
					adaptedPrescription
				];
			}
		}
	},
	[API_BULK_ANALYSES_PRESCRIPTION]: (state, action) => {
		state.analysisLoading = true;
	},

	[API_BULK_ANALYSES_PRESCRIPTION_FAIL]: (state, action) => {
		state.analysisLoading = false;
		errorHandler("Analyse", ErrorAction.UPDATE, action.error);
	},

	[API_BULK_ANALYSES_PRESCRIPTION_SUCCESS]: (state, action) => {
		state.analysisLoading = false;
		if (state.data && state.data.folders) {
			try {
				const client = action.meta?.previousAction?.payload?.client || getVersion(API_BULK_ANALYSES_PRESCRIPTION).currentClient;
				const adaptedPayload = adaptPayloadResponse(action, API_BULK_ANALYSES_PRESCRIPTION, client);
				
				console.log('API_BULK_ANALYSES_PRESCRIPTION_SUCCESS response:', {
					hasData: !!adaptedPayload?.data,
					hasAnalyses: !!adaptedPayload?.data?.analyses,
					analysesCount: adaptedPayload?.data?.analyses?.length,
					prescriptionId: adaptedPayload?.data?.id,
					client: client,
					rawResponse: action.payload?.data,
					adaptedData: adaptedPayload?.data,
					analysesInResponse: adaptedPayload?.data?.analyses
				});
				
				if (!adaptedPayload || !adaptedPayload.data || !adaptedPayload.data.id) {
					console.warn('API_BULK_ANALYSES_PRESCRIPTION_SUCCESS: Missing required data in response');
					return;
				}
				
				const folderId = action.meta?.previousAction?.payload?.folderId 
					|| adaptedPayload.data.folder_id 
					|| adaptedPayload.data.folderId
					|| (state.data.folders && state.data.folders.length > 0 ? state.data.folders[0].id : null);
				
				if (!folderId) {
					console.warn('API_BULK_ANALYSES_PRESCRIPTION_SUCCESS: Missing folderId', {
						meta: action.meta?.previousAction?.payload,
						adaptedData: adaptedPayload.data,
						stateFolders: state.data.folders
					});
					return;
				}
				
				folderIndex = state.data.folders.findIndex((elt) => elt.id === folderId);
				if (folderIndex > -1 && state.data.folders[folderIndex] && state.data.folders[folderIndex].prescriptions) {
					prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex((elt) => 
						Number(elt.id) === Number(adaptedPayload.data.id)
					);
					
					if (prescriptionIndex > -1) {
						const existingPrescription = state.data.folders[folderIndex].prescriptions[prescriptionIndex];
						
						const responseAnalyses = adaptedPayload.data.analyses;
						const shouldPreserveAnalyses = !responseAnalyses || 
							(Array.isArray(responseAnalyses) && responseAnalyses.length === 0) ||
							!Array.isArray(responseAnalyses);
						
						let finalAnalyses = [];
						if (shouldPreserveAnalyses && existingPrescription.analyses && existingPrescription.analyses.length > 0) {
							console.log('API_BULK_ANALYSES_PRESCRIPTION_SUCCESS: Preserving existing analyses (response had empty array)', {
								existingCount: existingPrescription.analyses.length,
								responseCount: responseAnalyses?.length || 0
							});
							finalAnalyses = existingPrescription.analyses;
						} else if (responseAnalyses && Array.isArray(responseAnalyses) && responseAnalyses.length > 0) {
							console.log('API_BULK_ANALYSES_PRESCRIPTION_SUCCESS: Using analyses from response', responseAnalyses.length);
							finalAnalyses = responseAnalyses;
						}
						
						const updatedPrescription = {
							...existingPrescription,
							...adaptedPayload.data,
							analyses: finalAnalyses,
							tubes: adaptedPayload.data.tubes && Array.isArray(adaptedPayload.data.tubes) && adaptedPayload.data.tubes.length > 0
								? adaptedPayload.data.tubes
								: (existingPrescription.tubes || []),
							scans: adaptedPayload.data.scans && Array.isArray(adaptedPayload.data.scans) && adaptedPayload.data.scans.length > 0
								? adaptedPayload.data.scans
								: (existingPrescription.scans || []),
							systematic_questions: adaptedPayload.data.systematic_questions && Array.isArray(adaptedPayload.data.systematic_questions) && adaptedPayload.data.systematic_questions.length > 0
								? adaptedPayload.data.systematic_questions
								: (existingPrescription.systematic_questions || []),
						};
						
						const fullyAdaptedPrescription = adaptPrescriptionResponse(updatedPrescription, client);
						
						state.data.folders[folderIndex].prescriptions = [
							...state.data.folders[folderIndex].prescriptions.slice(0, prescriptionIndex),
							fullyAdaptedPrescription,
							...state.data.folders[folderIndex].prescriptions.slice(prescriptionIndex + 1)
						];
					} else {
						console.warn('API_BULK_ANALYSES_PRESCRIPTION_SUCCESS: Prescription not found in state', {
							prescriptionId: adaptedPayload.data.id,
							availablePrescriptionIds: state.data.folders[folderIndex].prescriptions.map(p => p.id)
						});
					}
				}
			} catch (error) {
				console.error('Error in API_BULK_ANALYSES_PRESCRIPTION_SUCCESS:', error);
			}
		}
	},
	[API_DELETE_PRESCRIPTION_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			state.data.folders[folderIndex].prescriptions = state.data.folders[folderIndex].prescriptions.filter(
				(i) => i.id !== action.meta.previousAction.payload.prescriptionId
			);
		}
	},
	[API_PATCH_QUESTIONANSWER_FAIL]: (state, action) => {
		errorHandler(
			"Une erreur s'est produite lors de la mise à jour des réponses du questionnaire, veuillez rafraichir la page et rééssayer.",
			ErrorAction.UPDATE,
			action.error
		);
	},
	[API_PATCH_QUESTIONANSWER_SUCCESS]: (state, action) => {
		const answers = action.meta.previousAction.payload.data.answers;
		let currentAns;
		let result;
		if (action.payload.data) result = action.payload.data.result;

		state.data.folders.forEach((folder) => {
			folder.prescriptions.forEach((presc) => {
				// Systematic questions
				presc.systematic_questions.forEach((sysQ) => {
					currentAns = answers.find((i) => i.links.includes(sysQ.id));
					if (currentAns !== undefined) {
						sysQ.value = currentAns.value;
						sysQ.from_free_input = currentAns.from_free_input;
					}
				});

				presc.analyses.forEach((ana) => {
					ana.question_answers.forEach((qa) => {
						currentAns =
							result && result.some((i) => i.id === qa.id) ? result.find((i) => i.id === qa.id) : answers.find((i) => i.links.includes(qa.id));
						if (currentAns !== undefined) {
							qa.value = currentAns.value;
							if (currentAns.question && currentAns.question.motivation) qa.codes = currentAns.codes;
							qa.from_free_input = currentAns.from_free_input;
						}
					});
				});
			});
		});
	},
	[API_POST_SCAN_PRESCRIPTION]: (state, action) => {},
	[SET_TAB_RESULT]: (state) => {
		state.tab = 3;
	},
	[SET_TAB_ALIQUOT]: (state) => {
		state.tab = 3;
	},
	[SET_TAB_TUBES]: (state) => {
		state.tab = 2;
	},

	[SET_TAB_PRESC]: (state) => {
		state.tab = 0;
	},

	[API_POST_SCAN_PRESCRIPTION_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_POST_SCAN_PRESCRIPTION).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_POST_SCAN_PRESCRIPTION, client);
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			if (folderIndex > -1 && state.data.folders[folderIndex]) {
				prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex(
					(elt) => elt.id === action.meta.previousAction.payload.prescriptionId
				);
				if (!state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.map((sc) => sc.barcode).includes(adaptedPayload.data.barcode))
					state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.push(adaptedPayload.data);
				else
					state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans[
						state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.findIndex((elt) => elt.barcode === adaptedPayload.data.barcode)
					] = adaptedPayload.data;
			}
		}
	},

	[API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_POST_SCAN_PRESCRIPTION_UPDATE_PRESC, client);
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			if (folderIndex > -1 && state.data.folders[folderIndex]) {
				oldPrescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex(
					(elt) => elt.id === parseInt(action.meta.previousAction.payload.oldPrescriptionId)
				);
				prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex(
					(elt) => elt.id === parseInt(action.meta.previousAction.payload.prescriptionId)
				);
				if (state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans)
					state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.push(adaptedPayload.data);
				else state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans = [adaptedPayload.data];

				const removedIndex = state.data.folders[folderIndex].prescriptions[oldPrescriptionIndex].scans.findIndex(
					(scan) => scan.id === parseInt(adaptedPayload.data.id)
				);
				state.data.folders[folderIndex].prescriptions[oldPrescriptionIndex].scans.splice(removedIndex, 1);
			}
		}
	},

	[API_POST_SCAN_PRESCRIPTION_FAIL]: (state, action) => {
		if (action.error && action.error.response && action.error.response.status === 409) state.barcodeWarningOpen = true;
		else errorHandler("Page de prescription", ErrorAction.CREATE, action.error);
	},
	[API_DELETE_SCAN_PRESCRIPTION_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			if (folderIndex > -1 && state.data.folders[folderIndex]) {
				prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex(
					(elt) => elt.id === action.meta.previousAction.payload.prescriptionId
				);

				const removedIndex = state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.findIndex(
					(scan) => scan.id === parseInt(action.payload.data.id)
				);
				if (removedIndex !== -1) state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.splice(removedIndex, 1);
			}
		}
	},

	[API_PUT_VALID_PRESCRIPTION_SCAN_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_PUT_VALID_PRESCRIPTION_SCAN).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_PUT_VALID_PRESCRIPTION_SCAN, client);
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			if (folderIndex > -1 && state.data.folders[folderIndex]) {
				prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex(
					(elt) => elt.id === action.meta.previousAction.payload.prescriptionId
				);
				const updatedIndex = state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.findIndex(
					(scan) => scan.id === parseInt(adaptedPayload.data.id)
				);
				if (updatedIndex !== -1) state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans[updatedIndex] = adaptedPayload.data;
			}
		}
	},

	[API_PUT_QUALITY_PRESCRIPTION_SCAN_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_PUT_QUALITY_PRESCRIPTION_SCAN).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_PUT_QUALITY_PRESCRIPTION_SCAN, client);
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			if (folderIndex > -1 && state.data.folders[folderIndex]) {
				prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex(
					(elt) => elt.id === action.meta.previousAction.payload.prescriptionId
				);
				const updatedIndex = state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.findIndex(
					(scan) => scan.id === parseInt(adaptedPayload.data.id)
				);
				if (updatedIndex !== -1) state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans[updatedIndex] = adaptedPayload.data;
			}
		}
	},

	[API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_PUT_BAD_QUALITY_PRESCRIPTION_SCAN, client);
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			if (folderIndex > -1 && state.data.folders[folderIndex]) {
				prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex(
					(elt) => elt.id === action.meta.previousAction.payload.prescriptionId
				);
				const updatedIndex = state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.findIndex(
					(scan) => scan.id === parseInt(adaptedPayload.data.id)
				);
				if (updatedIndex !== -1) state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans[updatedIndex] = adaptedPayload.data;
			}
		}
	},

	[API_POST_PHOTO_FOLDER]: (state, action) => {},

	[API_POST_PHOTO_FOLDER_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			state.data.folders[folderIndex].photos.push(action.payload.data);
		}
	},
	[API_POST_PHOTO_FOLDER_FAIL]: (state, action) => {
		if (action.error.response.status === 409) state.barcodeWarningOpen = true;
		else errorHandler("Photo", ErrorAction.CREATE, action.error);
	},
	[API_DELETE_PHOTO_FOLDER_SUCCESS]: (state, action) => {
		if (state.data.folders) {
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.payload.data.folder);
			state.data.folders[folderIndex].photos = state.data.folders[folderIndex].photos.filter((i) => i.id !== Number(action.payload.data.id));
		}
	},
	[API_DELETE_PHOTO_FOLDER_FAIL]: (state, action) => {
		errorHandler("Photo", ErrorAction.DELETE, action.error);
	},
	[API_UPDATE_PHOTO_FOLDER_SUCCESS]: (state, action) => {
		const updatedPhoto = action.payload.data;
		if (state.data.folders) {
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);

			const photoIndex = state.data.folders[folderIndex].photos.findIndex((photo) => photo.id === updatedPhoto.id);
			state.data.folders[folderIndex].photos[photoIndex] = updatedPhoto;
		}
	},
	[API_UPDATE_PHOTO_FOLDER_FAIL]: (state, action) => {
		if (action.error.response.status === 409) state.barcodeWarningOpen = true;
		else errorHandler("Photo", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_TUBE]: (state, action) => {
		state.barcode = action.barcode;
	},

	[API_PATCH_TUBE_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getTubeVersion(API_PATCH_TUBE).currentClient;
			const adaptedPayload = adaptTubePayloadResponse(action, API_PATCH_TUBE, client);
			state.data.folders.forEach((folder) => {
				folder.prescriptions.forEach((pres) => {
					pres.tubes.forEach((tube) => {
						if (tube.id === adaptedPayload.data.id) {
							Object.assign(tube, adaptedPayload.data);
						}
					});
				});
			});
		}
	},
	[API_VALIDATE_FOLDERS_SUCCESS]: (state, action) => {},

	/** DELETE TUBE */
	[API_DELETE_TUBE]: (state, action) => {
		state.loading = true;
	},
	[API_DELETE_TUBE_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Tube", ErrorAction.DELETE, action.error);
	},
	[API_DELETE_TUBE_SUCCESS]: (state, action) => {
		const data = action.payload.data;

		state.loading = false;
		state.data.folders.forEach((folder) => {
			folder.prescriptions.forEach((presc) => {
				let tubeToRemove = null;
				presc.tubes.forEach((tube, index) => {
					if (data.tubes.includes(tube.id)) {
						tubeToRemove = index;
					}
				});
				if (tubeToRemove !== null) {
					presc.tubes.splice(tubeToRemove, 1);
				}
			});
		});
	},

	/** POST TUBES */
	[API_POST_TUBE]: (state, action) => {
		state.loading = true;
	},
	[API_POST_TUBE_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Tube", ErrorAction.CREATE, action.error);
	},
	[API_POST_TUBE_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getTubeVersion(API_POST_TUBE).currentClient;
			const adaptedPayload = adaptTubePayloadResponse(action, API_POST_TUBE, client);
			const data = adaptedPayload.data;
			let count = 0;

			state.loading = false;
			state.data.folders.forEach((folder) => {
				folder.prescriptions.forEach((presc) => {
					if (data && data[count]) {
						presc.tubes.push(data[count]);
						count++;
					}
				});
			});
		}
	},

	/** REPEATE PRESCRIPTION */
	[API_POST_REPEATABLE_PRESCRIPTION_FAIL]: (state, action) => {
		errorHandler("Prescription renouvelable", ErrorAction.CREATE, action.error);
	},
	[API_POST_REPEATABLE_PRESCRIPTION_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_POST_REPEATABLE_PRESCRIPTION).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_POST_REPEATABLE_PRESCRIPTION, client);
			const folderId = adaptedPayload.data.folder_id || adaptedPayload.data.folderId;
			folderIndex = state.data.folders.findIndex((elt) => elt.id === folderId);
			if (folderIndex > -1) {
				const adaptedPrescription = adaptPrescriptionResponse(adaptedPayload.data, client);
				state.data.folders[folderIndex].prescriptions = [
					...state.data.folders[folderIndex].prescriptions,
					adaptedPrescription
				];
			}
		}
	},

	/** GET PATIENT EXISTING FOLDER */
	[API_GET_PATIENT_EXISTING_FOLDER]: (state, action) => {
		state.loading = true;
		state.existing = null;
	},
	[API_GET_PATIENT_EXISTING_FOLDER_FAIL]: (state, action) => {
		state.loading = false;
		state.existing = null;
		errorHandler("Dossier", ErrorAction.READ, action.error);
	},
	[API_GET_PATIENT_EXISTING_FOLDER_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_GET_PATIENT_EXISTING_FOLDER).currentClient;
		const adaptedPayload = adaptFolderPayloadResponse(action, API_GET_PATIENT_EXISTING_FOLDER, client);
		const { existing } = adaptedPayload.data;
		state.existing = existing;
	},

	/** REOPEN FOLDER*/
	[API_PATCH_OPEN_FOLDER]: (state, action) => {
		state.loading = true;
	},
	[API_PATCH_OPEN_FOLDER_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Réouverture dossier", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_OPEN_FOLDER_SUCCESS]: (state, action) => {
		state.loading = false;
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_PATCH_OPEN_FOLDER).currentClient;
			const adaptedPayload = adaptFolderPayloadResponse(action, API_PATCH_OPEN_FOLDER, client);
			if (adaptedPayload.data && adaptedPayload.data.id) {
				const folderIndex = state.data.folders.findIndex((elt) => elt.id === adaptedPayload.data.id);
				if (folderIndex > -1) {
					state.data.folders[folderIndex] = adaptFolderResponse(adaptedPayload.data, client);
				}
			}
		}
	},

	/** SET PRESCRIPTION SCAN BARCODE */
	[API_POST_PRESCRIPTION_SCAN_BARCODE]: (state, action) => {
		state.barcode = action.barcode;
	},

	[API_POST_PRESCRIPTION_SCAN_BARCODE_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_POST_PRESCRIPTION_SCAN_BARCODE).currentClient;
		const adaptedPayload = adaptPayloadResponse(action, API_POST_PRESCRIPTION_SCAN_BARCODE, client);
		const folderIndex = state.data.folders.findIndex((elt) => elt.id === adaptedPayload.data.folder_id || adaptedPayload.data.folderId);
		if (folderIndex > -1 && state.data.folders[folderIndex]) {
			const prescriptionId = adaptedPayload.data.prescription_id || adaptedPayload.data.prescriptionId;
			const prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex((elt) => elt.id === prescriptionId);

			const scanId = adaptedPayload.data.scan_id || adaptedPayload.data.scanId;
			const scanIndex = state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans.findIndex(
				(elt) => elt.id === scanId
			);

			state.data.folders[folderIndex].prescriptions[prescriptionIndex].scans[scanIndex].barcode = adaptedPayload.data.barcode;
		}
	},
	[API_POST_PRESCRIPTION_SCAN_BARCODE_FAIL]: (state, action) => {
		if (action.error.response.status === 409) state.barcodeWarningOpen = true;
		else errorHandler("Code-barres", ErrorAction.UPDATE, action.error);
	},
	/** CHANGE PATIENT */
	[API_PATCH_FOLDER_PATIENT]: (state, action) => {
		state.loading = true;
	},
	[API_PATCH_FOLDER_PATIENT_SUCCESS]: (state, action) => {
		state.loading = false;
		const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_PATCH_FOLDER_PATIENT).currentClient;
		const adaptedPayload = adaptFolderPayloadResponse(action, API_PATCH_FOLDER_PATIENT, client);
		const { patient, folderId } = adaptedPayload.data;
		if (state.data && state.data.folders) {
			const folderIndex = state.data.folders.findIndex((elt) => elt.id === folderId);
			if (folderIndex > -1) {
				state.data.folders[folderIndex].patient = patient;
				state.data.patient = patient;
			}
		}
	},
	[API_PATCH_FOLDER_PATIENT_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Patient du dossier", ErrorAction.UPDATE, action.error);
	},
	/** CANCEL FOLDER*/
	[API_PATCH_CANCEL_FOLDER]: (state, action) => {
		state.loading = true;
	},
	[API_PATCH_CANCEL_FOLDER_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Annulation dossier", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_CANCEL_FOLDER_SUCCESS]: (state, action) => {
		state.loading = false;
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_PATCH_CANCEL_FOLDER).currentClient;
			const adaptedPayload = adaptFolderPayloadResponse(action, API_PATCH_CANCEL_FOLDER, client);
			if (adaptedPayload.data && adaptedPayload.data.id) {
				const folderIndex = state.data.folders.findIndex((elt) => elt.id === adaptedPayload.data.id);
				if (folderIndex > -1) {
					state.data.folders[folderIndex] = adaptFolderResponse(adaptedPayload.data, client);
				}
			}
		}
	},

	/** GET ALL FOLERS */
	[API_GET_ALL_FOLDER]: (state, action) => {
		state.loading = true;
	},
	[API_GET_ALL_FOLDER_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Dossier", ErrorAction.READ, action.error);
	},
	[API_GET_ALL_FOLDER_SUCCESS]: (state, action) => {
		state.loading = false;
		const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_GET_ALL_FOLDER).currentClient;
		const adaptedPayload = adaptFolderPayloadResponse(action, API_GET_ALL_FOLDER, client);
		state.folders = adaptedPayload.data;
	},

	[API_GET_SEARCH_FOLDERS]: (state, action) => {
		state.loading = true;
	},
	[API_GET_SEARCH_FOLDERS_FAIL]: (state, action) => {
		state.loading = false;
		errorHandler("Dossier", ErrorAction.READ, action.error);
	},
	[API_GET_SEARCH_FOLDERS_SUCCESS]: (state, action) => {
		state.loading = false;
		const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_GET_SEARCH_FOLDERS).currentClient;
		const adaptedPayload = adaptFolderPayloadResponse(action, API_GET_SEARCH_FOLDERS, client);
		state.searchedFolders = adaptedPayload.data.results;
	},

	[API_GET_FOLDER_IS_PAID]: (state, action) => {
		state.loading = true;
	},
	[API_GET_FOLDER_PAYMENT_CANCEL]: (state, action) => {
		state.loading = true;
	},
	[API_GET_FOLDER_PAYMENT_CANCEL_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptPaymentPayloadResponse(action, API_GET_FOLDER_PAYMENT_CANCEL);
		state.paid = adaptedPayload.data || { payments: [] };
	},
	[API_GET_FOLDER_PAYMENT_CANCEL_FAIL]: (state, action) => {
		state.loading = false;
		state.paid = action.payload.data;
	},

	[API_GET_FOLDER_IS_PAID_SUCCESS]: (state, action) => {
		state.loading = false;
		state.paid = action.payload.data;
	},
	[API_POST_FOLDER_PAYMENT_REF_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptPaymentPayloadResponse(action, API_POST_FOLDER_PAYMENT_REF);
		state.paid = adaptedPayload.data || { payments: [] };
	},
	[API_POST_FOLDER_PAYMENT_REF_FAIL]: (state, action) => {
		errorHandler("Trop perçu", ErrorAction.READ, action.error);
	},
	[API_POST_PAYMENT]: (state, action) => {
		state.loading = true;
	},
	[API_POST_PAYMENT_SUCCESS]: (state, action) => {
		state.loading = false;
		const adaptedPayload = adaptPaymentPayloadResponse(action, API_POST_PAYMENT);
		state.paid = adaptedPayload.data || { payments: [] };
	},
	[API_POST_PAYMENT_FAIL]: (state, action) => {
		state.loading = false;
		state.paid = { payments: [] };
	},
	[API_GET_FOLDER_IS_PAID_FAIL]: (state, action) => {
		state.loading = false;
		state.paid = { payments: [] };
	},
	[API_GET_TERMINALS]: (state, action) => {
		state.loading = true;
	},
	[API_GET_TERMINALS_SUCCESS]: (state, action) => {
		state.loading = false;
		state.terminals = action.payload.data;
	},
	[API_GET_TERMINALS_FAIL]: (state, action) => {
		state.loading = false;
		state.terminals = [];
	},

	/** GET FOLDER **/
	[API_GET_FOLDER_LOG]: (state, action) => {
		state.logs.loading = true;
		state.logs.list = [];
	},
	[API_GET_FOLDER_LOG_FAIL]: (state, action) => {
		errorHandler("Logs", ErrorAction.READ, action.error);
		state.logs.loading = false;
	},
	[API_GET_FOLDER_LOG_SUCCESS]: (state, action) => {
		state.logs.loading = false;
		state.logs.list = action.payload.data;
	},
	[API_PATCH_OPENED_BY_FAIL]: (state, action) => {
		state.openedByWarningOpen = true;
	},
	[API_PATCH_PAUSE_FOLDER_VALIDATION_FAIL]: (state, action) => {
		toast.error("Impossible de mettre le dossier en pause");
	},
	[API_PATCH_PAUSE_FOLDER_VALIDATION_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_PATCH_PAUSE_FOLDER_VALIDATION).currentClient;
			const adaptedPayload = adaptFolderPayloadResponse(action, API_PATCH_PAUSE_FOLDER_VALIDATION, client);
			if (adaptedPayload.data && adaptedPayload.data.id) {
				const folderIndex = state.data.folders.findIndex((elt) => elt.id === adaptedPayload.data.id);
				if (folderIndex > -1) {
					state.data.folders[folderIndex] = adaptFolderResponse(adaptedPayload.data, client);
				}
			}
		}
	},
	[CLOSE_BARCODE_WARNING]: (state, action) => {
		state.barcodeWarningOpen = false;
	},
	[CLOSE_OPENEDBY_WARNING]: (state, action) => {
		state.openedByWarningOpen = false;
	},
	[API_PATCH_COMMENTS_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_PATCH_COMMENTS).currentClient;
		const adaptedPayload = adaptFolderPayloadResponse(action, API_PATCH_COMMENTS, client);
		if (state.data && state.data.folders && state.data.folders[0]) {
			state.data.folders[0].comment = adaptedPayload.data.comment || adaptedPayload.data.comment;
		}
		if (state.data && state.data.patient) {
			state.data.patient.post_it = adaptedPayload.data.patient?.post_it;
			state.data.patient.last_update_post_it = adaptedPayload.data.patient?.last_update_post_it;
		}
	},
	[API_PATCH_COMMENTS_FAIL]: (state, action) => {
		errorHandler("Observation dossier et patient", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_FOLDER_GESLAB_ALERT_FAIL]: (state, action) => {
		errorHandler("Alerte GesLab", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_FOLDER_GESLAB_ALERT_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_PATCH_FOLDER_GESLAB_ALERT).currentClient;
		const adaptedPayload = adaptFolderPayloadResponse(action, API_PATCH_FOLDER_GESLAB_ALERT, client);
		if (state.data && state.data.folders && state.data.folders[0]) {
			state.data.folders[0].geslab_alert = adaptedPayload.data.geslab_alert || adaptedPayload.data.geslabAlert;
			state.data.folders[0].geslab_alert_comment = adaptedPayload.data.geslab_alert_comment || adaptedPayload.data.geslabAlertComment;
		}
	},
	[API_PATCH_FOLDER_FAMILY_LINK_FAIL]: (state, action) => {
		errorHandler("Lien famille", ErrorAction.UPDATE, action.error);
	},
	[API_PATCH_FOLDER_FAMILY_LINK_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_PATCH_FOLDER_FAMILY_LINK).currentClient;
		const adaptedPayload = adaptFolderPayloadResponse(action, API_PATCH_FOLDER_FAMILY_LINK, client);
		if (state.data && state.data.folders && state.data.folders[0]) {
			state.data.folders[0].family_link = adaptedPayload.data.family_link || adaptedPayload.data.familyLink;
			state.data.folders[0].family_count = adaptedPayload.data.family_count || adaptedPayload.data.familyCount;
		}
	},
	[API_GET_SEARCH_FOLDERS_FAMILY_LINK_FAIL]: (state, action) => {
		state.foldersFamilyLink = [];
		errorHandler("Dossier", ErrorAction.READ, action.error);
	},
	[API_GET_SEARCH_FOLDERS_FAMILY_LINK_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getFolderVersion(API_GET_SEARCH_FOLDERS_FAMILY_LINK).currentClient;
		const adaptedPayload = adaptFolderPayloadResponse(action, API_GET_SEARCH_FOLDERS_FAMILY_LINK, client);
		state.foldersFamilyLink = adaptedPayload.data;
	},

	[API_POST_SAFEPLACE_RESULT_PRESCRIPTION]: (state, action) => {},
	[API_POST_SAFEPLACE_RESULT_PRESCRIPTION_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_POST_SAFEPLACE_RESULT_PRESCRIPTION).currentClient;
		const adaptedPayload = adaptPayloadResponse(action, API_POST_SAFEPLACE_RESULT_PRESCRIPTION, client);
		state.data.folders.forEach((folder) => {
			folder.prescriptions.forEach((presc) => {
				presc.safeplace_result = adaptedPayload.data.safeplace_result || adaptedPayload.data.safeplaceResult;
			});
		});
		toast.success("Résultat sauvegardé");
	},
	[API_POST_SAFEPLACE_RESULT_PRESCRIPTION_FAIL]: (state, action) => {
		toast.error("Une erreur s'est produite lors de la sauvegarde du résultat. Veuillez réessayer.");
	},

	[API_POST_IATA_DID_PRESCRIPTION_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_POST_IATA_DID_PRESCRIPTION).currentClient;
		const adaptedPayload = adaptPayloadResponse(action, API_POST_IATA_DID_PRESCRIPTION, client);
		const iataDID = adaptedPayload.data?.iataDID || adaptedPayload.data?.iata_did;
		if (adaptedPayload.data && iataDID) toast.success("La connexion IATA est correctement établie.");
		else toast.success("La connexion IATA a été supprimée.");
	},

	[API_GET_PATIENT_IATA_QRCODE]: (state, action) => {
		state.data.iata = { loading: true };
	},
	[API_GET_PATIENT_IATA_QRCODE_SUCCESS]: (state, action) => {
		if (action.payload.data) {
			state.data.iata = action.payload.data;
		}
		state.data.iata = { ...state.data.iata, loading: !action.payload.data.url };
	},

	[API_GET_PATIENT_IATA_DID_SUCCESS]: (state, action) => {
		if (action.payload.data) {
			state.data.iata = action.payload.data;
		}
	},

	[API_CLEAR_PATIENT_IATA]: (state, action) => {
		state.data.iata = { loading: true };
	},
	[RESET_ALIQUOTS_WAITING]: (state, action) => {
		state.aliquotWaiting = [];
	},

	[API_GET_WAITING_ALIQUOTS_FOLDERS_SUCCESS]: (state, action) => {
		state.aliquotWaiting = action.payload.data;
	},

	//Get Folders not done with tubes included timer
	[API_GET_WAITING_TUBES_FOLDERS_SUCCESS]: (state, action) => {
		state.foldersWaiting = action.payload.data;
	},
	//Get My opened folders
	[API_GET_MY_OPENED_FOLDERS_SUCCESS]: (state, action) => {
		state.myOpenedFolders = action.payload.data.folders;
	},
	//Remove Folders association
	[API_DELETE_MY_OPENED_FOLDERS_SUCCESS]: (state, action) => {
		if (action.payload.data && action.payload.data.status) {
			toast.success(`${action.payload.data.status} dossiers ouverts ont été libérés.`);
			state.myOpenedFolders = [];
		}
	},
	[API_GET_FOLDER_HELP_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders && state.data.folders[0]) {
			const { getVersion } = require("services/folderHelp");
			const { adaptFolderHelpPayloadResponse } = require("reducers/folderHelp");
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_GET_FOLDER_HELP).currentClient;
			const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_GET_FOLDER_HELP, client);
			state.data.folders[0].folderHelp = adaptedPayload.data;
		}
	},
	[API_POST_COMMENT_FOLDER_HELP_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders && state.data.folders[0] && state.data.folders[0].folderHelp) {
			const { getVersion } = require("services/folderHelp");
			const { adaptFolderHelpPayloadResponse } = require("reducers/folderHelp");
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_POST_COMMENT_FOLDER_HELP).currentClient;
			const adaptedPayload = adaptFolderHelpPayloadResponse(action, API_POST_COMMENT_FOLDER_HELP, client);
			state.data.folders[0].folderHelp.comments = adaptedPayload.data?.comments || action.payload.data?.comments || [];
		}
	},
	[API_GET_RELOAD_SCANS_SUCCESS]: (state, action) => {
		if (state.data.folders && state.data.folders.length > 0 && state.data.folders[0] && state.data.folders[0].prescriptions) {
			const prescriptionIndex = state.data.folders[0].prescriptions.findIndex((elt) => elt.id === parseInt(action.payload.data.prescriptionId));
			if (prescriptionIndex > -1) state.data.folders[0].prescriptions[prescriptionIndex].scans = action.payload.data.scans;
		}
	},
	[API_PUT_MOTIVATION_SUCCESS]: (state, action) => {
		if (state.data.folders && state.data.folders.length > 0 && state.data.folders[0] && state.data.folders[0].prescriptions) {
			const prescriptionIndex = state.data.folders[0].prescriptions.findIndex(
				(elt) => elt.analyses && elt.analyses.find((a) => a.id === parseInt(action.payload.data.id))
			);
			if (prescriptionIndex > -1) {
				const analysisIndex = state.data.folders[0].prescriptions[prescriptionIndex].analyses.findIndex(
					(a) => a.id === parseInt(action.payload.data.id)
				);
				if (analysisIndex > -1)
					state.data.folders[0].prescriptions[prescriptionIndex].analyses[analysisIndex] = {
						...state.data.folders[0].prescriptions[prescriptionIndex].analyses[analysisIndex],
						...action.payload.data,
					};
			}
		}
	},
	[API_PUT_ENDO_ANSWERS_SUCCESS]: (state, action) => {
		if (state.data.folders && state.data.folders.length > 0 && state.data.folders[0] && state.data.folders[0].id === action.payload.data.folder?.id) {
			state.data.folders[0].endoAnswers = action.payload.data;
		}
	},
	[API_PUT_DEPOSIT_SUCCESS]: (state, action) => {
		const adaptedPayload = adaptDepositPayloadResponse(action, API_PUT_DEPOSIT);
		if (state.data.folders && state.data.folders.length > 0 && state.data.folders[0] && state.data.folders[0].id === adaptedPayload.data.folderId) {
			state.data.folders[0].deposit = adaptedPayload.data.deposit || null;
		}
	},
	[API_DELETE_DEPOSIT_SUCCESS]: (state, action) => {
		if (
			state.data.folders &&
			state.data.folders.length > 0 &&
			state.data.folders[0] &&
			state.data.folders[0].id === action.meta.previousAction.payload.folderId
		) {
			state.data.folders[0].deposit = null;
		}
	},

	[API_PATCH_CHECK_ANALYSIS_SUCCESS]: (state, action) => {
		if (state.data && state.data.folders) {
			const client = action.meta?.previousAction?.payload?.client || getVersion(API_PATCH_CHECK_ANALYSIS).currentClient;
			const adaptedPayload = adaptPayloadResponse(action, API_PATCH_CHECK_ANALYSIS, client);
			folderIndex = state.data.folders.findIndex((elt) => elt.id === action.meta.previousAction.payload.folderId);
			if (folderIndex > -1 && state.data.folders[folderIndex]) {
				const prescriptionId = adaptedPayload.data.prescription_id || adaptedPayload.data.prescriptionId;
				prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex((elt) => elt.id === +prescriptionId);

				if (prescriptionIndex > -1 && state.data.folders[folderIndex].prescriptions[prescriptionIndex]) {
					const analysisId = adaptedPayload.data.analysis_id || adaptedPayload.data.analysisId;
					analysisIndex = state.data.folders[folderIndex].prescriptions[prescriptionIndex].analyses.findIndex(
						(elt) => elt.id === +analysisId
					);
					const checkedBy = adaptedPayload.data.analysis?.checked_by || adaptedPayload.data.analysis?.checkedBy;
					if (
						analysisIndex > -1 &&
						state.data.folders[folderIndex].prescriptions[prescriptionIndex].analyses[analysisIndex].checked_by !==
							checkedBy
					) {
						state.data.folders[folderIndex].prescriptions[prescriptionIndex].analyses[analysisIndex].checked_by =
							checkedBy;
					}
				}
			}
		}
	},
	[API_PATCH_PRESCRIPTION_CONTACT_SUCCESS]: (state, action) => {
		const client = action.meta?.previousAction?.payload?.client || getVersion(API_PATCH_PRESCRIPTION_CONTACT).currentClient;
		const adaptedPayload = adaptPayloadResponse(action, API_PATCH_PRESCRIPTION_CONTACT, client);
		const folderId = adaptedPayload.data.folder_id || adaptedPayload.data.folderId;
		const folderIndex = state.data.folders.findIndex((elt) => elt.id === folderId);
		if (folderIndex > -1 && state.data.folders[folderIndex]) {
			const prescriptionId = adaptedPayload.data.prescription_id || adaptedPayload.data.prescriptionId;
			const prescriptionIndex = state.data.folders[folderIndex].prescriptions.findIndex((elt) => elt.id === prescriptionId);
			const prescription = adaptedPayload.data.prescription || adaptedPayload.data;
			state.data.folders[folderIndex].prescriptions[prescriptionIndex].to_be_phoned = prescription.to_be_phoned || prescription.toBePhoned;
			state.data.folders[folderIndex].prescriptions[prescriptionIndex].to_be_phoned_number = prescription.to_be_phoned_number || prescription.toBePhonedNumber;
			state.data.folders[folderIndex].prescriptions[prescriptionIndex].phone_to_patient = prescription.phone_to_patient || prescription.phoneToPatient;
			state.data.folders[folderIndex].prescriptions[prescriptionIndex].phone_to_patient_number =
				prescription.phone_to_patient_number || prescription.phoneToPatientNumber;
			state.data.folders[folderIndex].prescriptions[prescriptionIndex].paper_copy_to_patient = prescription.paper_copy_to_patient || prescription.paperCopyToPatient;
			state.data.folders[folderIndex].prescriptions[prescriptionIndex].to_be_faxed = prescription.to_be_faxed || prescription.toBeFaxed;
		}
	},
});

export default folderManager;
